/* eslint-disable eqeqeq */
import React from 'react';
import 'react-toastify/dist/ReactToastify.css';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { SelectInput, TextInput } from '../CustomerAccounts/LoanFormFields';

// Add / edit one activity of a construction plan (side panel). Same fields,
// limits and handlers as before; labels sit above the fields.
export default function Form({
  setActivityType, activityType, activityTypes,
  activityName,
  weightage,
  noOfImages,
  noOfVideos,
  handleChange,
  newForm,
  setActivityName,
  activitylevel,
  activityNameContainer,
  isPaymentMS,
  setisPaymentMS,
}) {
  return (
    <div className='lf-grid'>
      <SelectInput
        id='activityType'
        label='Activity type'
        span={12}
        disabled={!newForm}
        options={activityTypes.paginate.map((element) => ({
          value: element.id, label: element.activityType,
        }))}
        value={activityType}
        onChange={(event) => setActivityType(event)}
      />
      {activityNameContainer.length > 0 && (
        <SelectInput
          id='activityName'
          label='Activity name'
          span={12}
          options={activityNameContainer.map((element) => ({
            value: element.id, label: element.activityName,
          }))}
          value={activityName}
          onChange={(event) => setActivityName(event)}
        />
      )}
      {activitylevel && (
        <TextInput
          id='activitylevel'
          label='Activity level'
          span={12}
          disabled
          value={activitylevel}
        />
      )}
      <TextInput
        id='weightage'
        label='Weightage'
        span={4}
        type='number'
        suffix='%'
        value={weightage}
        onChange={(id) => {
          if (id.target.value == '' || (id.target.value > 0 && id.target.value < 101)) {
            handleChange(id);
          }
        }}
      />
      <TextInput
        id='noOfImages'
        label='Photos (max 10)'
        span={4}
        type='number'
        value={noOfImages}
        onChange={(id) => {
          if (id.target.value == '' || (id.target.value > -1 && id.target.value < 11)) {
            handleChange(id);
          }
        }}
      />
      <TextInput
        id='noOfVideos'
        label='Videos (max 2)'
        span={4}
        type='number'
        value={noOfVideos}
        onChange={(id) => {
          if (id.target.value == '' || id.target.value == 0 || id.target.value == 1 || id.target.value == 2) {
            handleChange(id);
          }
        }}
      />
      <div className='lf-span-12'>
        <FormControlLabel
          control={(
            <Checkbox
              color='primary'
              size='small'
              checked={isPaymentMS === 'True'}
              onChange={(event) => setisPaymentMS(event)}
              name='Applicable'
            />
          )}
          label='Payment milestone'
        />
      </div>
    </div>
  );
}
